import { render, staticRenderFns } from "./BaseRadioButton.vue?vue&type=template&id=9f37a0e4&"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js&"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports